import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import DealerLogin from './pages/DealerLogin';
import DealerDashboard from './pages/DealerDashboard';
import DealerClientView from './pages/DealerClientView';
import ClientSSOLanding from './pages/ClientSSOLanding';

export default function App() {
  const [client, setClient] = useState(null);
  const [admin,  setAdmin]  = useState(null);
  const [dealer, setDealer] = useState(null);

  const path = window.location.pathname;

  useEffect(() => {
    if (path.startsWith('/admin')) {
      const a = localStorage.getItem('nb_admin');
      const t = localStorage.getItem('nb_admin_token');
      if (a && t) setAdmin(JSON.parse(a));

    } else if (path.startsWith('/dealer-client')) {
      // SSO page — DealerClientView handles its own auth

    } else if (path.startsWith('/sso-landing')) {
      // Tools-section client SSO landing — ClientSSOLanding handles its own
      // auth (stores nb_token/nb_client, then full-reloads to '/'), so the
      // normal client bootstrap below must not run on this path.

    } else if (path.startsWith('/dealer')) {
      const d = localStorage.getItem('nb_dealer');
      const t = localStorage.getItem('nb_dealer_token');
      if (d && t) setDealer(JSON.parse(d));

    } else {
      const raw = localStorage.getItem('nb_client');
      const tok = localStorage.getItem('nb_token');
      if (!raw || !tok) return;
      try {
        // Check JWT expiry without verifying signature
        const payload = JSON.parse(atob(tok.split('.')[1]));
        if (Date.now() >= payload.exp * 1000) {
          localStorage.removeItem('nb_token');
          localStorage.removeItem('nb_client');
          return;
        }
        const stored = JSON.parse(raw);
        // ── Pass ALL client fields — mobile, email, dob included ──
        setClient({
          name:   stored.name       || stored.clientName || '',
          ucc:    stored.ucc        || '',
          mobile: stored.mobile     || '',
          email:  stored.email      || '',
          dob:    stored.dob        || '',
        });
      } catch {
        localStorage.removeItem('nb_token');
        localStorage.removeItem('nb_client');
      }
    }
  }, []);

  // ── Client Tools SSO landing ──
  if (path.startsWith('/sso-landing')) {
    return <ClientSSOLanding />;
  }

  // ── Dealer SSO client view ──
  if (path.startsWith('/dealer-client')) {
    return <DealerClientView />;
  }

  // ── Admin flow ──
  if (path.startsWith('/admin')) {
    if (!admin) return <AdminLogin onLoginSuccess={a => setAdmin(a)} />;
    return <AdminDashboard admin={admin} onLogout={() => { localStorage.removeItem('nb_admin'); localStorage.removeItem('nb_admin_token'); setAdmin(null); }} />;
  }

  // ── Dealer flow ──
  if (path.startsWith('/dealer')) {
    if (!dealer) return <DealerLogin onLoginSuccess={d => setDealer(d)} />;
    return <DealerDashboard dealer={dealer} onLogout={() => { localStorage.removeItem('nb_dealer'); localStorage.removeItem('nb_dealer_token'); setDealer(null); }} />;
  }

  // ── Client flow ──
  const handleLoginSuccess = (data) => {
    const clientData = {
      name:   data.clientName || data.name || '',
      ucc:    data.ucc        || '',
      mobile: data.mobile     || '',
      email:  data.email      || '',
      dob:    data.dob        || '',
    };
    // Update localStorage with full data so page refresh works
    localStorage.setItem('nb_client', JSON.stringify(clientData));
    setClient(clientData);
  };

  const handleLogout = () => {
    localStorage.removeItem('nb_token');
    localStorage.removeItem('nb_client');
    setClient(null);
  };

  if (!client) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return <Dashboard client={client} onLogout={handleLogout} />;
}